import React from 'react'
import styled from 'styled-components'
import ParticlesJS from 'react-particles-js'

const Particles = styled(ParticlesJS)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  color: blue;
  z-index: -1;
`

export default () => (
  <Particles
    params={{
      particles: {
        number: {
          value: 80,
          density: {
            enable: true,
            value_area: 800,
          },
        },
        color: {
          value: '#ffffff',
        },
        line_linked: {
          enable: true,
          distance: 150,
          color: '#c8c8c8',
          opacity: 0.4,
          width: 1,
        },
        move: {
          speed: 0.5,
        },
      },
    }}
  />
)
